export default "__VITE_ASSET__DaA_Mvl$__"